export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/de.lyaml"));
vm(require("feature-monetization/lang/de.lyaml"));
at({ "de": { "publicPricingPage": { "windowTitles": { "default": "Preise | HubSpot" } } } });
};